import MyWelcomeMessages from "@/domain/entities/dashboard/WelcomeMessages";
import { WelcomeMessages } from "@cs_teamwaydev/mailvista-sdk_react";

const welcomeMessagesMapper = (
    welcomeMessages: WelcomeMessages,
): MyWelcomeMessages =>
    new MyWelcomeMessages({
        newMailsCount: welcomeMessages.newMailsCount,
        importantMailsCount: welcomeMessages.importantMailsCount,
        savedCO2Kg: welcomeMessages.savedCO2Kg,
    });

export default welcomeMessagesMapper;
